import styled, { keyframes } from 'styled-components';

const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ColorChange = keyframes`
  0% {
    --x: 0%;
    --y: 0%;
  }
  25% {
    --x: 100%;
    --y: 0%;
  }
  50% {
    --x: 100%;
    --y: 100%;
  }
  75% {
    --x: 0%;
    --y: 100%;
  }
  100% {
    --x: 0%;
    --y: 0%;
  }
`;

const LightSource = styled.div`
  width: 100%;
  height: 100%;
  transition: background-color 1s, background-image 1s, background 1s;
  background-color: var(--shine-bg-color);
  background: radial-gradient(circle farthest-corner at var(--x) var(--y), var(--shine-secondary-bg-color) 0%, var(--shine-bg-color) 50%, var(--shine-bg-color) 100%);
  background-attachment: fixed;
  animation: ${ColorChange} 20s infinite;

  @supports (not(--value: 0)) {
    /* CSS variables not supported */
  }
`;

export default LightSource;
